import isEqual from 'lodash/isEqual'

import get from 'lodash/get'

import {
  listingsIsLoading,
  setExpiredSessionTimestamp,
  listingsHasErrored,
  setOverfilteredBannerText,
  setOverfilteredStatus,
  listingsLoadingMessage,
  listingsLoadMoreSuccess,
  displayInfiniteScrollLoadMore,
  updateBrandReference,
  setListingsMetaData,
} from '../actionCreators'

import { flyGaLogic } from '../../../util/flyGaLogic'
import { canLoadMoreitins } from '../../../util/canLoadMoreitins'

import { airSearch } from '../../../services/airSearch'
import {
  buildFlySearchDisplayFilterObj,
  buildFlySearchDisplayFiltersObj,
  scrollTopWhenRequired,
} from '../../../util/listingsHelpers'

import { flySliceSelectionStorage } from '../../../components/Legacy/fly-slice-selection-storage/fly-slice-selection-storage'
import { flySearchResponseData } from '../../../models/FlySearchResponseModel'
// eslint-disable-next-line no-unused-vars
import { resetAllAds } from '../../ads'
import { handleError } from '../helpers/handleError/handleError.js'
import { updateUrlWithFilterParams } from '../../../util/filter/setUrlFilterParams'
import { setInitialFilterInfo } from '../../filters'

import { airSearchRequestModel } from '../../../services/airSearch/airSearchRequest'
import { getIsSbs } from '../../../util/sbs'
import { getLoadingScreenMessage } from './helpers'

/**
 * Make airSearch call for filtering, sorting, and slice selection
 */
export function listingsFilterCall(PCLN_BOOTSTRAP_DATA, displayType = '') {
  return (dispatch, getState) => {
    const isSBS = getIsSbs()

    const isSliceSelection = displayType === 'sliceSelection'

    let loadingScreenMessage = getLoadingScreenMessage(
      isSliceSelection,
      displayType
    )

    const { latestFilterChange, defaults } = getState().filterInfo
    if (!isSliceSelection && displayType !== 'sort') {
      /**
       * The following check makes sure that updateUrlWithFilterParams is not called for
       * TIME and Duration Filters saving function calls
       *  */
      const callUpdateUrlWithFilterParams =
        latestFilterChange.numOfStops ||
        latestFilterChange.includedCarriers ||
        latestFilterChange.origAirports1

      // Update URL on changing the filters.
      if (!isSBS && callUpdateUrlWithFilterParams) {
        updateUrlWithFilterParams(latestFilterChange, defaults)
      }

      flyGaLogic.fire.filterTags(latestFilterChange, defaults)
    }

    dispatch(listingsIsLoading(true))
    dispatch(listingsLoadingMessage(loadingScreenMessage))
    dispatch(setExpiredSessionTimestamp())
    dispatch(listingsHasErrored(false))

    const sliceSelectionFilters = flySliceSelectionStorage.getFiltersStorage()

    const rebookAirline = get(
      PCLN_BOOTSTRAP_DATA,
      'searchRequest.params[included-airlines]',
      ''
    )

    if (isSBS) {
      const tabId = getState().activeTabId
      buildFlySearchDisplayFiltersObj({
        filter: getState().filterInfo,
        sliceSelectionFilters,
        selectedSort: null,
        isFiltersReq: true,
        activeTabId: tabId,
        isSliceSelection,
        rebookAirline,
      })

      if (isSliceSelection) {
        flySearchResponseData.filters[tabId - 1] = {
          sliceRefId: tabId - 1,
          filterDefaults: getState().filterInfo.defaults,
          AIRLINES: getState().airlinesFilter,
          AIRPORTS: getState().airportsFilter,
          DATE: getState().altDatesFilter,
          DEFAULT_TAB_ITEMS: getState().filterInfo.defaults.DEFAULT_TAB_ITEMS,
          DEFAULT_TIME: getState().filterInfo.defaults.DEFAULT_TIME,
          NUM_OF_STOPS: getState().stopsFilter,
          SLICE_ARRAY: getState().filterInfo.defaults.SLICE_ARRAY,
          TIME: getState().timeFilter,
        }
      }
    } else {
      buildFlySearchDisplayFilterObj({
        filter: getState().filterInfo,
        sliceSelectionFilters,
        selectedSort: null,
        isFiltersReq: true,
      })
    }

    return airSearchGraphPromise()

    function logError(error, sliceLength) {
      window?.newrelic?.noticeError(error)
      flyGaLogic.fire.filteredResponse(
        error.code || error.errorCode,
        sliceLength
      )
    }

    function airSearchGraphPromise() {
      const activeTabId = getState().activeTabId
      airSearch({
        pclnBootstrapData: PCLN_BOOTSTRAP_DATA,
        fromFilters: true,
        fromSlice: isSliceSelection,
      })
        .then(res => {
          const { response } = res

          const { listingsMetaData, filterDefaults, listings } = response

          const {
            requestId,
            lowerBound,
            upperBound,
            filteredCount,
            totalFilteredItineraries,
          } = listingsMetaData

          //  TODO: Is this tagging needed
          // This is based on the assumption that the lowest priced itinerary will always be returned on the top
          const firstItinerary = response.listings[0]
          if (
            firstItinerary &&
            !firstItinerary.isExpressDeal &&
            firstItinerary.isFused
          ) {
            flyGaLogic.fire.splitLowestPriceFullResult(
              response.listingsMetaData.tripType,
              !!firstItinerary.isFused,
              firstItinerary.interline
            )
          }

          const { filter = {} } = airSearchRequestModel
          const { sliceFilters = [] } = filter

          // AIR_LISTINGS_ATTRIBUTE_FILTER_CACHED
          // https://priceline.atlassian.net/browse/AIR-47790
          const hasAttributeFilters = sliceFilters.some(
            filter => filter?.attributes?.length
          )
          // we have fetched all that we can fetch, don't fetch any more
          const loadMore =
            !hasAttributeFilters &&
            canLoadMoreitins(upperBound, totalFilteredItineraries)

          const brandReference = get(response, 'brandReference', [])

          if (
            brandReference &&
            !isEqual(get(getState(), 'brandReference'), brandReference)
          ) {
            dispatch(updateBrandReference(brandReference))
          }

          /**
           * TODO: Refactor this abomination
           */
          const listingsObj = {
            response: listings,
          }

          /**
           * Some of the meta data that was set on initial request need not be overridden,
           * Override the fields that are necessary
           **/
          const metaData = {
            requestId,
            lowerBound,
            upperBound,
            filteredCount,
          }

          const isSBS = getIsSbs()

          dispatch(listingsIsLoading(false))
          dispatch(setListingsMetaData(metaData))
          dispatch(listingsLoadMoreSuccess(listingsObj))
          dispatch(displayInfiniteScrollLoadMore(loadMore))
          dispatch(setOverfilteredBannerText(false))
          dispatch(setOverfilteredStatus(false))
          dispatch(setListingsMetaData(get(response, 'listingsMetaData', null)))

          // Set Filter Defaults
          if (isSBS && displayType === 'sliceSelection') {
            dispatch(
              setInitialFilterInfo(filterDefaults, { isSBS, activeTabId })
            )
          }

          scrollTopWhenRequired(displayType)
        })
        .catch(error => {
          const sliceLength = airSearchRequestModel.slices.length

          logError(error, sliceLength)
          handleError(dispatch, error, 'FILTER')
          if (activeTabId !== 1) {
            dispatch(listingsLoadMoreSuccess({ response: [] }))
            dispatch(displayInfiniteScrollLoadMore(false))
          }
        })
    }
  }
}
